<ng-container *ngIf="!disableContentPage; else contentWithoutWrapper">
  <gatewee-content-page
    [breadcrumb]="
      breadcrumb.length
        ? breadcrumb
        : [
            {label: titlePath | translate, path: '/panel'},
            {label: title | translate}
          ]
    "
    [title]="title | translate"
  >
    <div page-body>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </gatewee-content-page>
</ng-container>

<ng-template #contentWithoutWrapper>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</ng-template>

<ng-template #contentTemplate>
  <div class="gw-flex gw-justify-end gw-mb-6">
    <gatewee-button
      [title]="'features.apiKeys.buttonText' | translate"
      variant="primary"
      iconName="@phi.plus"
      (click)="openCreateModal()"
    ></gatewee-button>
  </div>

  <div
    class="gw-rounded-xl gw-shadow-sm gw-border gw-border-border-normal gw-overflow-hidden"
  >
    <gatewee-table-v2
      *ngIf="keys && columns.length"
      [data]="keys"
      [columns]="columns"
      [page]="page"
      [pageSize]="pageSize"
      [total]="total || keys.length"
      [showSettings]="true"
      [tableId]="'api-keys-table'"
      (outClick)="onActionClicked($event)"
      (newPage)="onPageChange($event)"
    ></gatewee-table-v2>
  </div>
</ng-template>

<!-- Create API Key Modal -->
<ng-template #createKeyModal let-close>
  <div
    class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
  >
    <h4
      class="gw-text-xl gw-font-semibold gw-text-text-primary"
      id="modal-create-key-title"
    >
      {{ 'features.apiKeys.modal.title' | translate }}
    </h4>
  </div>
  <div class="gw-p-6">
    <form [formGroup]="createForm">
      <div class="gw-mb-6">
        <gatewee-input
          [form]="createForm"
          controlName="description"
          label="features.apiKeys.modal.descriptionLabel"
          id="create-key-description"
          type="text"
          [required]="false"
        ></gatewee-input>
      </div>
      <div class="gw-mb-6">
        <gatewee-input
          [form]="createForm"
          controlName="allowList"
          label="features.apiKeys.modal.ipLabel"
          id="create-key-allowList"
          type="text"
          [required]="true"
          [placeholder]="'features.apiKeys.modal.ipPlaceholder' | translate"
        ></gatewee-input>
        <p class="gw-text-sm gw-text-text-secondary gw-mt-2">
          {{ 'features.apiKeys.modal.ipHint' | translate }}
        </p>
        <p
          *ngIf="
            createForm.get('allowList')?.invalid &&
            createForm.get('allowList')?.touched
          "
          class="gw-text-sm gw-text-status-negative gw-mt-1"
        >
          {{ 'features.apiKeys.modal.ipError' | translate }}
        </p>
      </div>
      <div class="gw-flex gw-justify-end gw-gap-3">
        <gatewee-button
          [title]="'common.actions.cancel' | translate"
          variant="secondary"
          (click)="closeCreateModal(close)"
          [disabled]="loading"
        ></gatewee-button>
        <gatewee-button
          [title]="'features.apiKeys.modal.submit' | translate"
          variant="primary"
          (click)="handleCreate(close)"
          [disabled]="createForm.invalid || loading"
        ></gatewee-button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Key View Modal -->
<ng-template #keyViewModal let-close>
  <div
    class="gw-flex gw-items-center gw-justify-between gw-border-b gw-border-border-normal"
  >
    <h4
      class="gw-text-xl gw-font-semibold gw-text-text-primary"
      id="modal-key-view-title"
    >
      {{
        (postCreateReveal
          ? 'features.apiKeys.view.titleReveal'
          : 'features.apiKeys.view.title'
        ) | translate
      }}
    </h4>
  </div>
  <div *ngIf="selectedKey as sk">
    <div>
      <div
        *ngIf="postCreateReveal"
        class="gw-rounded-lg gw-border gw-border-status-warning gw-bg-background-elevation-1"
      >
        <p class="gw-text-sm gw-font-semibold gw-text-text-primary">
          {{ 'features.apiKeys.view.revealBannerTitle' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-secondary">
          {{ 'features.apiKeys.view.revealBannerBody' | translate }}
        </p>
        <ul
          class="gw-list-disc gw-pl-5 gw-text-sm gw-text-text-secondary gw-space-y-1"
        >
          <li>{{ 'features.apiKeys.view.revealChecklistKey' | translate }}</li>
          <li *ngIf="sk.publicKey">
            {{ 'features.apiKeys.view.revealChecklistPublicKey' | translate }}
          </li>
          <li>
            {{ 'features.apiKeys.view.revealChecklistSecret' | translate }}
          </li>
        </ul>
        <p class="gw-text-sm gw-text-status-warning gw-font-medium">
          {{ 'features.apiKeys.view.revealSecretOnce' | translate }}
        </p>
      </div>

      <div *ngIf="postCreateReveal">
        <p class="gw-text-sm gw-font-medium gw-text-text-secondary">
          {{ 'features.apiKeys.view.copySectionIntro' | translate }}
        </p>
        <div>
          <div>
            <label
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
            >
              {{ 'features.apiKeys.view.copyFieldKey' | translate }}
            </label>
            <div class="gw-flex gw-gap-2">
              <input
                type="text"
                readonly
                class="gw-flex-1 gw-min-w-0 gw-p-3 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 gw-text-text-primary gw-font-mono gw-text-sm"
                [value]="sk.key"
              />
              <gatewee-button
                [title]="'features.apiKeys.modal.copy' | translate"
                variant="secondary"
                (click)="copyToClipboard(sk.key)"
              ></gatewee-button>
            </div>
          </div>
          <div *ngIf="sk.publicKey as pub">
            <label
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
            >
              {{ 'features.apiKeys.view.copyFieldPublicKey' | translate }}
            </label>
            <div class="gw-flex gw-gap-2">
              <input
                type="text"
                readonly
                class="gw-flex-1 gw-min-w-0 gw-p-3 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 gw-text-text-primary gw-font-mono gw-text-sm"
                [value]="pub"
              />
              <gatewee-button
                [title]="'features.apiKeys.modal.copy' | translate"
                variant="secondary"
                (click)="copyToClipboard(pub)"
              ></gatewee-button>
            </div>
          </div>
          <div *ngIf="ephemeralSecret as sec">
            <label
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
            >
              {{ 'features.apiKeys.view.copyFieldSecret' | translate }}
            </label>
            <div class="gw-flex gw-gap-2">
              <input
                type="text"
                readonly
                class="gw-flex-1 gw-min-w-0 gw-p-3 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 gw-text-text-primary gw-font-mono gw-text-sm"
                [value]="sec"
              />
              <gatewee-button
                [title]="'features.apiKeys.modal.copy' | translate"
                variant="secondary"
                (click)="copyToClipboard(sec)"
              ></gatewee-button>
            </div>
          </div>
        </div>
        <div
          *ngIf="sk.key || sk.publicKey || ephemeralSecret"
          class="gw-flex gw-justify-end gw-pt-4"
        >
          <gatewee-button
            [title]="'features.apiKeys.view.copyAll' | translate"
            variant="secondary"
            (click)="copyAllCredentials()"
            iconName="@tui.copy"
          ></gatewee-button>
        </div>
      </div>

      <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-4">
        <div *ngIf="sk.id != null">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.apiKeys.table.columns.id' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">{{ sk.id }}</p>
        </div>
        <div *ngIf="!postCreateReveal && sk.key">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.apiKeys.table.columns.key' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">{{ sk.key }}</p>
        </div>
        <div *ngIf="!postCreateReveal && sk.publicKey">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.apiKeys.table.columns.publicKey' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary gw-break-all">
            {{ sk.publicKey }}
          </p>
        </div>
        <div *ngIf="sk.description">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.apiKeys.table.columns.description' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ sk.description }}
          </p>
        </div>
        <div *ngIf="sk.enabled !== undefined">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.apiKeys.table.columns.enable' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{
              sk.enabled
                ? ('features.apiKeys.status.true' | translate)
                : ('features.apiKeys.status.false' | translate)
            }}
          </p>
        </div>
        <div *ngIf="sk.allowList?.length">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.apiKeys.table.columns.allowList' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ sk.allowList.join(', ') }}
          </p>
        </div>
        <div *ngIf="sk.createdAt">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.apiKeys.table.columns.createdAt' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ sk.createdAt | date : 'dd/MM/yyyy HH:mm:ss' }}
          </p>
        </div>
        <div *ngIf="sk.lastActivity?.createdAt">
          <label
            class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
          >
            {{ 'features.apiKeys.table.columns.lastActivity' | translate }}
          </label>
          <p class="gw-text-base gw-text-text-primary">
            {{ getLastActivityDisplay(sk) }}
          </p>
        </div>
      </div>
      <div
        *ngIf="sk.enabled && actions.onDisable"
        class="gw-border-t gw-border-border-normal gw-pt-6"
      >
        <gatewee-button
          [title]="'features.apiKeys.table.menu.disable' | translate"
          variant="secondary"
          (click)="onDisableInView(close)"
          [disabled]="loading"
          iconName="@tui.ban"
        ></gatewee-button>
      </div>
    </div>
  </div>
</ng-template>
